module.exports = __webpack_public_path__ + "img/logo.f487e492.png";